"use client";

import { base } from "@biom3/design-tokens";
import { Box, Typography } from "@mui/material";
import Link from "next/link";
import { usePathname } from "next/navigation";

const Footer = () => {
  const pathname = usePathname();
  const isRewardsPage = pathname?.includes("/rewards");

  return (
    <Box
      component="footer"
      sx={{
        p: 4,
        bgcolor: base.color.translucent.inverse[150],
        borderRadius: base.borderRadius.x8,
      }}
    >
      {isRewardsPage ? (
        // Rewards-specific footer content
        <>
          <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
            <Link
              href="https://www.immutable.com/perpetual-rewards-terms"
              target="_blank"
              rel="noopener noreferrer"
            >
              Terms and Conditions apply.
            </Link>{" "}
            NO PURCHASE IS NECESSARY TO ENTER OR TO RECEIVE A REWARD. A PURCHASE
            DOES NOT INCREASE THE CHANCE OF RECEIVING A REWARD. The promotion is
            open worldwide to eligible entrants aged 18+. Where prohibited by
            law in a country or region, this promotion is void and not available
            to residents of that country or region; such residents are
            ineligible and rewards cannot be received. <br />
            This promotion is sponsored and promoted by the IMX Ecosystem
            Foundation and operated by Immutable Play.
          </Typography>
          <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
            These{" "}
            <Link
              href="https://www.immutable.com/terms-of-service"
              target="_blank"
              rel="noopener noreferrer"
            >
              Terms and Service
            </Link>{" "}
            govern your use of the platform and its services. For details on how
            your personal information is handled, please see our{" "}
            <Link
              href="https://www.immutable.com/terms/privacy-policy"
              target="_blank"
              rel="noopener noreferrer"
            >
              Privacy Policy
            </Link>
          </Typography>
        </>
      ) : (
        <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
          Use of this site constitutes acceptance of our{" "}
          <Link
            href="https://www.immutable.com/terms-of-service"
            target="_blank"
            rel="noopener noreferrer"
          >
            Terms and Service
          </Link>{" "}
          and acknowledgment of our{" "}
          <Link
            href="https://www.immutable.com/terms/privacy-policy"
            target="_blank"
            rel="noopener noreferrer"
          >
            Privacy Policy
          </Link>
          .
        </Typography>
      )}
    </Box>
  );
};

export default Footer;
